import React from 'react';
import { Drawer} from 'antd';

const RightDrawerSidebar = (props) => {
    return (
    <Drawer className="rightSiderbarMask"
                title={<><h3>{props.title}</h3><span>{props.subtitle}</span></>}
                placement={'right'}
                width={props?.type == "dummy_order" ? 500 : 400}
                onClose={props.onClose}
                visible={props.visible}
                // extra={
                //     <Space>
                //         {props.extra.map(ext=> ext)}
                //     </Space>
                // }
            >
                {props.children}
            </Drawer>
    );
};
export default RightDrawerSidebar;